import { useState } from "react";
import { addNotificationsForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import DropDownFilterPaginationsMulti from "../../components/GDropDownList/DropDownFilterPaginationsMulti";
import { useTranslation } from "react-i18next";

export default function AddNotificationsUi({ usersData, search }) {

    const nav = useNavigate();
    const [userId, setUserId] = useState(null)
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const onchange = (e) => {
        setUserId(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
        if(userId != null && userId != undefined && userId != []){
            formData.append("user_ids[]",userId);
        };
        if(userId == {} || userId == [] || userId == ""){
            formData.delete("user_ids[]");
            const result = await addNotificationsForm(formData, navigate);
        }
        else{
            const result = await addNotificationsForm(formData, navigate);
        };

        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };


    if ((usersData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "adress" : " العنوان"} </label>
                    <input
                        type="text"
                        name="title"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter notification title" : " أدخل عنوان الاشعار"} 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "description" : " الوصف"} </label>
                    <input
                        type="text"
                        name="description"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter notification description" : "أدخل وصف الاشعار "} 
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "to user" : " المستخدم"} </label>
                    <DropDownFilterPaginationsMulti search={search} options={usersData} value={userId} onchange={onchange} defaultText={currentLang === "en" ? "choose user" : "أختر مستخدم مخصص (اختياري) "} />
                    <label className="block text-gray mb-2">{currentLang === "en" ? "Select a user to whom the notification will be sent only." : "اختيار مستخدم ما سيخصص الاشعار له فقط"}</label>
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};